import { IVariableControl } from '../services/variable-controls/_base-control';

export interface IDisplayMetadata {

    type?: string;
    template: string;
    templateData: any;
    formControl?: IVariableControl;
}

export class DisplayMetadata implements IDisplayMetadata {

    type: string;
    template: string;
    templateData: any;
    formControl: IVariableControl;

    constructor(metadata: IDisplayMetadata) {
        this.type = metadata.type;
        this.template = (metadata.template || 'input').toLowerCase();
        this.templateData = metadata.templateData || {};
    }
}


export interface IFieldMetadata {
    order: number;
    type: string;
    template: string;
    templateData: any;
    displayName: string;
    propertyName: string;
}



export interface CompletionProcess {
    categoriesCount?: number;
    completionProcesssId?: string;
    pageIndex: number;
}
